export function getCaseStatusLabel(status) {
  switch (String(status || "").toUpperCase()) {
    case "DRAFT":
      return "Abierto"
    case "IN_PROGRESS":
      return "En tratamiento"
    case "FOLLOW_UP":
      return "En seguimiento"
    case "COMPLETED":
      return "Cerrado"
    case "CANCELLED":
      return "Cancelado"
    default:
      return status || "Sin estado"
  }
}

export function getEvolutionStatusLabel(status) {
  switch (String(status || "").toUpperCase()) {
    case "DRAFT":
      return "Borrador"
    case "REGISTERED":
      return "Registrada"
    case "CORRECTED":
      return "Corregida"
    case "CLOSED":
      return "Cerrada"
    default:
      return status || "Sin estado"
  }
}

export function getCaseStatusTone(status) {
  switch (String(status || "").toUpperCase()) {
    case "DRAFT":
      return "info"
    case "IN_PROGRESS":
      return "info"
    case "FOLLOW_UP":
      return "warning"
    case "COMPLETED":
      return "success"
    case "CANCELLED":
      return "danger"
    default:
      return "neutral"
  }
}